import ajax from '@/utils/ajax';

export const head = '/web';
// 获取用户信息
export const reqUserInfo = () => ajax(`${head}/v1/user/info`);
// 编辑头像
export const reqUserImage = (data) => ajax(`${head}/v1/user/info/edit-image?avatar=${data}`, '', 'PUT');
// 保存个人信息
export const resSaveInfo = (data) => ajax(`${head}/v1/user/info/save`, data, 'POST');

// 账号安全
// 发送短信验证码
export const reqVerification = (data) => ajax(`${head}/v1/user/safety/send-code?phone=${data.phone}&type=${data.type}`, '', 'POST');

// 校验短信验证码
export const reqVerifyVerification = (data) => ajax(`${head}/v1/user/safety/verify-code?code=${data.code}&phone=${data.phone}&type=${data.type}`, '', 'POST');

// 个人设置账户安全变更手机号
export const reqModifyPhone = (data) => ajax(`${head}/v1/user/safety/modify-phone?phone=${data.phone}`, '', 'PUT');

// 个人设置账户安全修改密码
export const reqModifyPassword = (data) => ajax(`${head}/v1/user/safety/modify-password?password=${data}`, '', 'PUT');
